import { ReactElement } from "react";
import { PaymentsModalType } from "entities/shared/subscriptionModel";
import { subscriptionStore } from "entities/Subscription";
import { useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";
import styles from "./PaymentsModalTitle.module.scss";

export const PaymentsModalTitle: RFC = () => {
  const { t } = useTranslation();

  const activePaymentModal = useAppSelector(subscriptionStore.selectors.activePaymentModal);

  const paymentsModalTitleMap: Record<PaymentsModalType, ReactElement> = {
    [PaymentsModalType.PAY]: <p className={styles.title}>{t("Continue with the right plan")}</p>,
    [PaymentsModalType.FREE]: <p className={styles.title}>{t("You're currently on the free version")}</p>,
  };

  if (!activePaymentModal) return null;

  return paymentsModalTitleMap[activePaymentModal];
};
